// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qyf6","controls":"styles_controls__21Jm5","charLimit":"styles_charLimit__1Zsot","input":"styles_input__1o7hf","send":"styles_send__3Eqnw"};